<template>

  <v-data-table-extended
      :headers="headers"
      :items="items"
      :items-per-page="5"
      csv-filename="orders"
    :loading="loading"
  >
    <template v-slot:item.created="{ item }">
      <span>{{new Date(item.created).toLocaleString()}}</span>
    </template>
    <template v-slot:item.completed="{ item }">
      <span>{{ item.completed ? 'Ja' : 'Nein'}}</span>
    </template>
    <template v-slot:item.metadata.newsletter="{ item }">
      <span>{{ item.metadata.newsletter === 'true' ? 'Ja' : 'Nein'}}</span>
    </template>
    <template v-slot:item.metadata.postcard="{ item }">
      <span>{{ item.metadata.postcard === 'true' ? 'Ja' : 'Nein'}}</span>
    </template>
    <template v-slot:item.files.org.url="{ item }">
      <a :href="item.files.org?.url" target="_blank">Upload</a>
    </template>
    <template v-slot:item.files.print.url="{ item }">
      <a :href="item.files.print?.url" target="_blank">Print</a>
    </template>
  </v-data-table-extended>
</template>

<script>

export default {
name: "ParticipantsTable",
  props:['participants', 'loading'],
  data: () => ({
    headers: [
        {text: 'Vorname', value: 'metadata.firstname'},
        {text: 'Nachname', value: 'metadata.lastname'},
        {text: 'Straße', value: 'metadata.street'},
        {text: 'PLZ', value: 'metadata.zip'},
        {text: 'Land', value: 'metadata.country'},
        {text: 'Telefon', value: 'metadata.phone'},
        {text: 'Email', value: 'metadata.email'},
        {text: 'Bestelldatum', value: 'created'},
        {text: 'Erledigt', value: 'completed'},
        {text: 'Newsletter', value: 'metadata.newsletter'},
        {text: 'Postcard', value: 'metadata.postcard'},
        {text: 'UserId', value: 'metadata.uid'},
        {text: 'UploadFile', value: 'files.org.url'},
        {text: 'Print', value: 'files.print.url'}

        ],
  }),
  mounted() {
  console.log(this.participants)
  },
  computed: {
    // headers2() {
    //    var h = [];
    //  const keys =  Object.keys(this.participants[100].data.metadata);
    //   keys.forEach((key) => {
    //     h.push({text: key, value: key});
    //   })
    //   return h;
    // },
    items() {
      var h = [];
      this.participants.forEach((key) => {
        h.push(key.data);
      })
      return h;
    }
  },
}
</script>

<style scoped>

</style>
